__webpack_require__.p = "https://seresl.unl.edu/webcamstudy/";